import qs from 'qs'
//获取页面高度
const getHeight = () => {
  return document.documentElement.clientHeight
};
//添加到localStorage
const setLocal = (name, val) => {
  let data = JSON.stringify(val)
  localStorage.setItem(name, data)
};
//删除localStorage
const deleteItem = (val) => {
  localStorage.removeItem(val);
};
//请求转换格式
const formData = (val) => {
  return qs.stringify(val)
};
//设置cookie
const setCookie = (name, value, seconds) => {
  seconds = seconds || 0; //seconds有值就直接赋值，没有为0
  let expires = "";
  if (seconds !== 0) { //设置cookie生存时间
    let date = new Date();
    date.setTime(date.getTime() + (seconds * 1000));
    expires = "; expires=" + date.toGMTString();
  }
  document.cookie = name + "=" + value + expires + "; path=/"; //转码并赋值
};
//获取cookie
const getCookie = (name) => {
  //cookie中的数据都是以分号加空格区分开
  let arr = document.cookie.split("; ");
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].split("=")[0] == name) {
      return arr[i].split("=")[1];
    }
  }
  //未找到对应的cookie则返回空字符串
  return '';
};
//删除cookie
const removeCookie = (name) => {
  //调用setCookie方法，把时间设置为-1
  setCookie(name, "", -24 * 60 * 60);
};
//转时间
const format = (str) => {
  const add = (m) => {
    return m < 10 ? '0' + m : m
  };
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return y + '-' + add(m) + '-' + add(d) + ' ' + add(h) + ':' + add(mm) + ':' + add(s);
};
//转时间带秒 2022-07-20T02:00:00.000+0000 > '10:00:00'
const formatTime = (str) => {
  const add = (m) => {
    return m < 10 ? '0' + m : m
  };
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return add(h) + ':' + add(mm) + ':' + add(s);
};
//转时间不带秒 2022-07-20T02:00:00.000+0000 > '10:00'
const formatTimes = (str) => {
  const add = (m) => {
    return m < 10 ? '0' + m : m
  };
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return add(h) + ':' + add(mm);
};
// export
//后端日期转正常日期 2022-09-03T08:32:12.000+0000 > 2022-09-03
const formatDate = (str) => {
  const add = (m) => {
    return m < 10 ? '0' + m : m
  };
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return y + '-' + add(m) + '-' + add(d);
};
//后端日期转正常日期 2022-09-03T08:32:12.000+0000 > 2022年9月3号
const formatDateC = (str) => {
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return y + '年' + m + '月' + d+'日';
};
// 保留小数点
const retainDecimal =(number,num)=> {  //number数值，num保留几位
  const fractionDigits = num; // 保留2位小数
  let result = +`${number}e${fractionDigits}`; // 145.78
  result <<= 0; // 145
  result = +`${result}e${-fractionDigits}`; // 1.45
  return result;
};
// 获取本月开始时间和结束时间
const getStartTimeAndEndTimeOfThisMonth = (time)=>{
  const newDate = new Date(formaMount(time));
  const year =  newDate.getFullYear();
  const month =  newDate.getMonth();
  let startTime = formatDate(new Date(year,month,1));
  let endTime =   formatDate(new Date(year,month+1,0));
  return {startTime,endTime}
}
// export
//后端日期转正常日期 2022-09-03T08:32:12.000+0000 > 2022-09
const formaMount = (str) => {
  const add = (m) => {
    return m < 10 ? '0' + m : m
  };
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return y + '-' + add(m)
};
//后端日期时间转正常日期时间 2022-09-03T08:32:12.000+0000 > 2022-09-03 16:32
const formats = (str) => {
  const add = (m) => {
    return m < 10 ? '0' + m : m
  };
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return y + '-' + add(m) + '-' + add(d) + ' ' + add(h) + ':' + add(mm);
};
//后端日期时间转正常日期时间 2022-09-03T08:32:12.000+0000 > 2022-09-03 16:32:00
const formatsS = (str) => {
  const add = (m) => {
    return m < 10 ? '0' + m : m
  };
  const time = new Date(str);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return y + '-' + add(m) + '-' + add(d) + ' ' + add(h) + ':' + add(mm) + ':' + add(s);
};
// 时分秒转秒'00:05:00' > 300  前端使用：300 * 1000
var formatHMStoS = function (time) {
  var s = '';
  var hour = time.split(':')[0];
  var min = time.split(':')[1];
  var sec = time.split(':')[2];
  s = Number(hour*3600) + Number(min*60) + Number(sec);
  return s;
};
var timeOut = function (){
  setTimeout(() => {
    return true
  }, formatHMStoS('00:10:00') * 1000);
}
const GetQueryString = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
const arrayDG = (array) => {
  let arr = []
  arrayPush(arr, array, [])
  return arr
}
const arrayPush = (arr, array, content) => {
  array.forEach((item) => {
    let idArr = JSON.parse(JSON.stringify(content))
    idArr.push(item.id)
    if (item.childNode) {
      arrayPush(arr, item.childNode, idArr)
    } else {
      arr.push(idArr)
    }
  })

}
const arrayPush2 = (arr, array, content) => {
  array.forEach((item) => {
    let idArr = JSON.parse(JSON.stringify(content))
    idArr.push(item.id)
    if (item.childNode) {
      arrayPush(arr, item.childNode, idArr)
    } else {
      arr.push(idArr)
    }
  })
  return arr
}

// 相差天数
const DateDiff=(time)=>{
    const sDate = new Date(time)*1;
    const eDate = new Date()*1;
    // if (sDate > eDate) {
    //     return 0
    // }
    if (sDate === eDate) {
        return 1
    }
    const days = ( sDate - eDate) / (1000 * 60 * 60 * 24)
    return parseInt(days);
}

// RateTodo
const rateTodo = (total,totalNumber)=>{
  let num = total == 0 ? 0: (Math.round((parseFloat(totalNumber) / parseFloat(total)) * 10000) / 100.0).toFixed(1);
  return num;
}
// RateTodo
const rateTodo2 = (total,totalNumber)=>{
  let num = totalNumber == 0 ? 0: (Math.round((parseFloat(totalNumber) / parseFloat(total)) * 10000) / 100.0).toFixed(1);
  return num;
}
export const loadView = (view) => { // 路由懒加载
  // let v = view.replace('../components/','')
  return (resolve) => require([`@/components/${view}`], resolve)
}
const getQueryVariable = (variable) => {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return (false);
}
const yearList = () => {
  return [
    {label: '2019', value: 2019},
    {label: '2020', value: 2020},
    {label: '2021', value: 2021},
    {label: '2022', value: 2022},
  ]
}
const year = () => {
  return 2021
}

const fixedFourNum = (num)=>{
  return ((Math.round(num*10000))/10000)
}
export default {
  retainDecimal,
  formatDateC,
  getStartTimeAndEndTimeOfThisMonth,
formaMount,
  formatsS,
  rateTodo2,
  rateTodo,
  DateDiff,
  timeOut,
  formatHMStoS,
  getHeight,
  setLocal,
  deleteItem,
  formData,
  setCookie,
  getCookie,
  removeCookie,
  format,
  formatTime,
  formatDate,
  formatTimes,
  formats,
  GetQueryString,
  arrayDG,
  arrayPush2,
  loadView,
  getQueryVariable,
  yearList,
  year,
  fixedFourNum
}
